"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _package = _interopRequireDefault(require("../package.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//import { transform } from 'zqyl-module-standalone'
var _default = {
  version: _package["default"].version,
  domain: ['lc.dev.yljr.com', 'lc.test.yljr.com', 'localhost'],
  contentType: {
    get: 'application/x-www-form-urlencoded',
    post: 'application/json;charset=UTF-8'
  },
  baseUrl: function baseUrl() {
    var pathname = window.location.pathname.split("/")[1];
    if (pathname.includes("zqyl-")) {
      return "/".concat(pathname);
    } else {
      return "";
    }
  },
  //初始化当前page数据对象
  initDataSource: function initDataSource(dataSource) {
    var _this2 = this;
    window.LOWCODE["source"] = {};
    try {
      if (dataSource) {
        dataSource.map(function (item) {
          item.children.map(function (child) {
            if (child.type == "js") {
              var updateObject = _this2.execute(child.body);
              window.LOWCODE["source"][child.target] = updateObject;
            }
            if (child.type == "api") {
              var tempPageObject = {};
              child.params.map(function (item) {
                tempPageObject[item.key] = item.body;
              });
              window.LOWCODE["source"][child.target] = Object.assign({
                url: child.body,
                method: child.method,
                params: tempPageObject,
                data: {},
                proxy: child.proxy,
                success: child.success,
                error: child.error
              });
            }
            if (child.type == "base") {
              window.LOWCODE["source"][child.target] = Object.assign({
                data: child.data,
                highKey: child.highKey
              });
            }
          });
        });
      }
    } catch (e) {
      console.warn("初始化数据源错误", e);
    }
  },
  filters: function filters(str) {
    var status = true;
    var context = ['this.$refs', 'this.$route', 'this.$router', 'window.', 'state.pageObject'];
    context.map(function (item) {
      if (str.indexOf(item) != -1) {
        status = false;
      }
    });
    return status ? "\"".concat(str, "\"") : str;
  },
  // 首字母大小
  charUpperCase: function charUpperCase(str) {
    return str.replace(/( |^)[a-z]/g, function (L) {
      return L.toUpperCase();
    });
  },
  //首字母小写
  charLowerCase: function charLowerCase(str) {
    return str.replace(str[0], str[0].toLowerCase());
  },
  //json串 转 对象
  getJsonObject: function getJsonObject(data) {
    if (data && typeof data == "string") {
      var charIndex = data.indexOf("{");
      var scriptStr = charIndex != -1 ? data.substring(charIndex) : this.filters(data);
      var res = eval("(function(window){\n                return (".concat(scriptStr, ")\n            }.call(window.LOWCODE.app,window))"));
      if (res) {
        return res;
      } else {
        return typeof res == 'boolean' ? res : res == null || res == undefined ? '' : res;
      }
    } else {
      return data;
    }
  },
  // getJsonObject(data){
  //     if(data && typeof data == "string"){
  //         let charIndex = data.indexOf("{");
  //         let scriptStr = charIndex != -1 ? data.substring(data.indexOf("{")) : this.filters(data);
  //         let res = ""
  //         const sourceScript = `res = (function(window){
  //             return (${scriptStr})
  //         }.call(window.LOWCODE.app,window))`;
  //         const transCode = transform(sourceScript,{
  //             presets: [['env',{ modules: false}]]
  //         }).code;
  //         eval(transCode)
  //         if(res){
  //             return res;
  //         }else{
  //             return typeof res == 'boolean' ? res : (res == null || res == undefined ? '' : res)
  //         }
  //     }else{
  //         return data;
  //     }
  // },
  //替换{{}}符号
  replaceObjectChars: function replaceObjectChars(jsonStr) {
    try {
      var replacedStr = this.replaceRefs(jsonStr);
      return replacedStr;
    } catch (e) {
      return jsonStr;
    }
  },
  replaceRefs: function replaceRefs(str) {
    var replaced = this.replaceChars(str);
    return this.replaceObject(replaced);
  },
  replaceObject: function replaceObject(str) {
    if (str.includes('$refs')) {
      str = str.replace(/\$refs/g, 'window.LOWCODE.$refs');
    }
    if (str.includes('JSObject')) {
      str = str.replace(/JSObject/g, 'window.LOWCODE.source.JSObject');
    }
    if (str.includes('API')) {
      str = str.replace(/API/g, 'window.LOWCODE.source.API');
    }
    return str;
  },
  replaceChars: function replaceChars(jsonStr) {
    return jsonStr && jsonStr.replace(/\{{2,}/g, '').replace(/\}{2,}/g, '');
  },
  replaceVal: function replaceVal(jsonStr) {
    return jsonStr.replace("{{", "${").replace("}}", "}");
  },
  execute: function execute(jsonString) {
    return this.getJsonObject(this.replaceObjectChars(jsonString));
  },
  executeEvent: function executeEvent(bindEvent, data) {
    var _this = this;
    return function () {
      if (bindEvent && bindEvent.method[0] == "js") {
        return window.LOWCODE.source[bindEvent.method[1]][bindEvent.method[2]](data);
      }
      if (bindEvent && bindEvent.method[0] == "api") {
        return window.LOWCODE.source[bindEvent.method[1]].run(data);
      }
      if (bindEvent && !bindEvent.isAction && bindEvent.body) {
        return _this.execute(bindEvent.body);
      }
    };
  },
  //matchField 与 createMatchField 由于第二个参数用于eval计算，待优化
  matchField: function matchField(data, arg) {
    var charIndex = data ? data.indexOf("{{") : '';
    if (charIndex != -1 && data) {
      var varChar = data.match(/{{(\S*)}}/);
      var replaced = varChar[0].replace(/\{{2,}/g, ',').replace(/\}{2,}/g, ',');
      var replaceArr = replaced ? replaced.split(',') : [];
      var resValue = '';
      replaceArr.forEach(function (item) {
        if (item) {
          if (item.includes('arg')) {
            resValue += eval(item);
          } else {
            resValue += item;
          }
        }
      });
      return this.execute(varChar.input.replace(varChar[0], resValue));
    } else {
      return data;
    }
  },
  createMatchField: function createMatchField(data, scope) {
    var _this3 = this;
    var charIndex = data ? data.indexOf("{{") : '';
    if (data && charIndex != -1) {
      var varChar = data.match(/{{(\S*)}}/);
      var replaced = varChar[0].replace(/\{{2,}/g, ',').replace(/\}{2,}/g, ',');
      var replaceArr = replaced ? replaced.split(',') : [];
      var resValue = '';
      replaceArr.forEach(function (item) {
        if (item) {
          if (item.includes('scope')) {
            resValue += eval(item);
          } else {
            resValue += _this3.execute(item);
          }
        }
      });
      return varChar.input.replace(varChar[0], resValue);
    } else {
      return data;
    }
  },
  createMatchTextHtml: function createMatchTextHtml(data, scope) {
    var _this4 = this;
    var charIndex = data ? data.indexOf("{{") : '';
    if (data && charIndex != -1) {
      var replaceArr = data.match(/\{\{([^{}]+)\}\}/g);
      replaceArr.forEach(function (item) {
        if (item) {
          var replaceData = "";
          if (item.includes('scope')) {
            replaceData = eval(item);
          } else {
            replaceData = _this4.execute(item);
          }
          data = data.replace(item, replaceData);
        }
      });
      return data;
    } else {
      return data;
    }
  },
  getRepId: function getRepId(proxyAddress, url) {
    var arr = proxyAddress.split("/");
    var id = arr[arr.length - 1] || arr[arr.length - 2];
    return isNaN(id) || !url ? false : Number(id);
  },
  assignData: function assignData(scheme, value, assignment) {
    var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    var searchField = arguments.length > 4 ? arguments[4] : undefined;
    var pathTemp = path;
    for (var key in scheme) {
      if (scheme[searchField] == value) {
        assignment.push(pathTemp);
        return false;
      }
      ;
      if (_typeof(scheme[key]) == "object") {
        if (isNaN(key) == false) {
          path = pathTemp + "[" + key + "]";
        } else {
          path = pathTemp == "" ? key : pathTemp + "." + key;
        }
        this.assignData(scheme[key], value, assignment, path, searchField);
      }
    }
  },
  //读取数据位置数据
  getReduceResult: function getReduceResult(source, dataPath) {
    var dataPathArr = dataPath.split(".");
    return dataPathArr.reduce(function (pre, item, i) {
      return pre[item];
    }, source);
  },
  replaceArrayMark: function replaceArrayMark(str) {
    var newStr = str.replace(/\[/g, ".").replace(/\]/g, "");
    return newStr.charAt(0) == "." ? newStr.substr(1) : newStr;
  },
  getComponentVmodel: function getComponentVmodel(el, confGlobal) {
    var target = el.__config__.target;
    var assignment = [];
    this.assignData(confGlobal, target, assignment, '', 'target');
    var indexAll = [];
    var positionArr = [];
    var vmodelValue = null;
    if (assignment && assignment.length > 0) {
      positionArr = assignment[0].split(".");
      positionArr.forEach(function (item, index) {
        if (item == "__config__") {
          indexAll.push(index);
        }
      });
    }
    return this.matchTarget(indexAll, positionArr, confGlobal);
  },
  matchTarget: function matchTarget(indexList, positionArr, confGlobal) {
    var _this5 = this;
    var result = [false, ''];
    indexList.forEach(function (item) {
      var node = positionArr.slice().splice(0, item);
      var path = _this5.replaceArrayMark(node.join("."));
      var source = _this5.getReduceResult(confGlobal, path);
      if (source["__config__"].tagType == 'arrayObject') {
        result = [true, ''];
      }
      if (source["__config__"].tagType == 'elForm') {
        result = [false, source];
      }
    });
    return result;
  },
  getAxiosBase: function getAxiosBase(data) {
    return window.LOWCODE['power'].includes(window.location.hostname) && data.proxy ? data.proxy : '/';
  },
  //获取API参数值
  getParams: function getParams() {
    var _this6 = this;
    for (var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++) {
      arg[_key] = arguments[_key];
    }
    var params = {};
    var item = arg[0];
    if (item.params) {
      item.params.forEach(function (child) {
        params[child.key] = _this6.matchField(child.body, arg[1]);
      });
    }
    return params;
  }
};
exports["default"] = _default;